<template>
  <b-tab :title="__('Payment Gateways')">
    <PackagePaymentGateways />
  </b-tab>
</template>

<script>
import PackagePaymentGateways from './Settings';

export default {
  components: {
    PackagePaymentGateways,
  },
};
</script>
